var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"burger burger2",class:{on: _vm.hamburger},on:{"click":function($event){return _vm.toggleMenu()}}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }